import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { match } from 'ts-pattern'
import { useNavigation } from '@/app/hooks'
import useCostCategories from '@/hooks/useCostCategories'

export default function useViewModel() {
  const { thermostatId } = useParams<{ thermostatId: string }>()
  const navigate = useNavigation()

  const {
    costCategories,
    isLoading: costCategoryControlsLoading,
    submitUpdateForm,
  } = useCostCategories(Number.parseInt(thermostatId))
  const lowPriceCategory = costCategories.find((c) => c.minValue === 0)
  const highPriceCategory = costCategories.find(
    (c) => c.maxValue === Number.POSITIVE_INFINITY,
  )
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    const loading =
      costCategoryControlsLoading || !lowPriceCategory || !highPriceCategory
    if (!loading) {
      setIsLoading(loading)
    }
  }, [costCategoryControlsLoading, lowPriceCategory, highPriceCategory])
  const [localCostCategories, setLocalCostCategories] = useState(
    [] as typeof costCategories,
  )
  useEffect(() => {
    if (costCategories && costCategories.length > 0) {
      setLocalCostCategories(costCategories)
    }
  }, [costCategories])

  const updateLocalCostCategories = (
    categories: typeof costCategories,
    lowPriceCost: number,
    highPriceCost: number,
  ) => {
    const updatedCategories = categories.map((c) => {
      const newMaxValue = match(c.type)
        .with('low', () => lowPriceCost)
        .with('medium', () => highPriceCost)
        .otherwise(() => c.maxValue)
      const newMinValue = match(c.type)
        .with('high', () => highPriceCost)
        .with('medium', () => lowPriceCost)
        .otherwise(() => c.minValue)
      return {
        ...c,
        maxValue: Math.round(newMaxValue),
        minValue: Math.round(newMinValue),
      }
    })
    setLocalCostCategories(updatedCategories)
  }

  const onDiscardClick = () => {
    navigate.push(`/devices/thermostat/${thermostatId}/cost-categories`)
  }
  return {
    costCategories,
    lowPriceCategory,
    highPriceCategory,
    isLoading,
    localCostCategories,
    updateLocalCostCategories,
    submitUpdateForm,
    onDiscardClick,
  }
}
